import {SidebarCollapseIcon, SidebarExpandIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useCollapsibleSidebarContext} from '../CollapsibleSidebar/CollapsibleSidebar'
import {SidebarTooltip} from '../SidebarTooltip/SidebarTooltip'
import type {Ref} from 'react'
import styles from './CollapseButton.module.css'

export interface CollapseButtonProps {
  ref?: Ref<HTMLButtonElement>
}

export function CollapseButton({ref}: CollapseButtonProps) {
  const {isExpanded, visualIsExpanded, isExpansionSettled, isInDialog, sidebarId, onToggle} =
    useCollapsibleSidebarContext()
  const label = isExpanded ? 'Collapse sidebar' : 'Expand sidebar'
  const IconComponent = visualIsExpanded ? SidebarExpandIcon : SidebarCollapseIcon
  if (isInDialog) return null
  return (
    <SidebarTooltip text={label} disabled={visualIsExpanded}>
      <Button
        data-component="Sidebar.CollapseButton"
        ref={ref}
        className={styles.CollapseButton}
        data-collapsed={!visualIsExpanded || undefined}
        leadingVisual={IconComponent}
        alignContent="start"
        labelWrap={isExpansionSettled}
        variant="invisible"
        onClick={onToggle}
        aria-expanded={isExpanded}
        aria-controls={sidebarId}
        aria-label={label}
      >
        {visualIsExpanded ? <span data-sidebar-collapse-content>Collapse sidebar</span> : null}
      </Button>
    </SidebarTooltip>
  )
}
